var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.maintenance)?_c('div',[_c('maintenance')],1):_c('div',{},[_c('home-template')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }